import axios, { Method } from '@/apps/open/utils/axios'

const resourceName = '/serviceapi/vas_open'

export function getVasInfo (id: string) {
  return axios({ url: `${resourceName}/v1/${id}`, method: Method.Get })
}

export function getVasList (id: string, data: object) {
  return axios({ url: `${resourceName}/v1/${id}/order`, method: Method.Get, params: data })
}

export function setVasCallkack (id: string, data: object) {
  return axios({ url: `${resourceName}/v1/${id}`, method: Method.Post, data: data })
}
